import React from 'react';

const sizes = {
  large: {
    height: '56px',
    padding: '8px 24px',
    fontSize: '16px',
    iconSize: 20,
  },
  small: {
    height: '40px',
    padding: '4px 16px',
    fontSize: '14px',
    iconSize: 16,
  },
};

export default function TitleCard({
  label = 'Button',
  variant = 'primary',
  size = 'large',
  onClick,
  iconLeft,
  iconRight,
  loading = false,
  style = {},
  ...rest
}) {
  const iconSize = sizes[size].iconSize;

  return (    
    <div
      className='title-card'
      style={style}
      onClick={onClick}
      {...rest}
    >
      {iconLeft && <span>{React.cloneElement(iconLeft, { size: iconSize })}</span>}
      <span style={{marginLeft: '5px'}}>{label}</span>
      {iconRight && <span>{React.cloneElement(iconRight, { size: iconSize })}</span>}
    </div>
  );
}